export const avatarUrl = (width = 300): string =>
	`https://7w7z6ydf2htamqdsm6nbxm7sma0nkltc.lambda-url.eu-central-1.on.aws/2026-07-27/me-2026.jpg?f=scaled&q=9&w=${width}`
